import { integrationLabel } from "../../utils/integrations";

// Integration-portal apps: ids are canonical keys, names are registry labels.
export const APPS = ["jahez", "hungerstation", "keeta", "toyou", "marsool", "ninja", "thechefz"].map((id) => ({
  id,
  name: integrationLabel(id, "ar"),
  nameEn: integrationLabel(id, "en"),
}));

export const REQUEST_STATUSES = [
  { id: "draft", label: "مسودة", labelEn: "Draft", final: false },
  { id: "sent", label: "قيد الانتظار", labelEn: "Waiting", final: false },
  {
    id: "req_in_progress",
    label: "قيد المعالجة",
    labelEn: "In progress",
    final: false,
  },
  {
    id: "pending_confirm",
    label: "بانتظار الاعتماد",
    labelEn: "Pending confirmation",
    final: false,
  },
  {
    id: "clarify",
    label: "يتطلب توضيح",
    labelEn: "Clarification required",
    final: false,
  },
  { id: "done", label: "تم الحل", labelEn: "Resolved", final: true },
  { id: "rejected", label: "مرفوض", labelEn: "Rejected", final: true },
];

export const REQUEST_TYPES = {
  link_app: {
    label: "طلب ربط تطبيق",
    labelEn: "App connection request",
    icon: "link",
    cat: "link",
  },
  disconnect_app: {
    label: "طلب إيقاف ربط",
    labelEn: "Disconnect request",
    icon: "unlink",
    cat: "link",
  },
  activate_branch: {
    label: "طلب تفعيل فرع",
    labelEn: "Branch activation request",
    icon: "activate",
    cat: "link",
  },
  close_branch: {
    label: "طلب إغلاق فرع",
    labelEn: "Branch closure request",
    icon: "close",
    cat: "link",
  },
  menu_update: {
    label: "تحديث المنيو",
    labelEn: "Menu update",
    icon: "menu",
    cat: "edit",
  },
  issue: {
    label: "بلاغ مشكلة فنية",
    labelEn: "Technical issue report",
    icon: "issue",
    cat: "edit",
  },
};

export const DAYS = [
  { id: "sunday", label: "الأحد", labelEn: "Sunday" },
  { id: "monday", label: "الاثنين", labelEn: "Monday" },
  { id: "tuesday", label: "الثلاثاء", labelEn: "Tuesday" },
  { id: "wednesday", label: "الأربعاء", labelEn: "Wednesday" },
  { id: "thursday", label: "الخميس", labelEn: "Thursday" },
  { id: "friday", label: "الجمعة", labelEn: "Friday" },
  { id: "saturday", label: "السبت", labelEn: "Saturday" },
];

export const OPEN_STATUSES = [
  "draft",
  "sent",
  "req_in_progress",
  "pending_confirm",
  "clarify",
];

export const tx = (ar, en, isArabic) => (isArabic ? ar : en);
